export default __webpack_public_path__ + "static/media/T61.ffb8d45c.JPG";